import { slideDown, slideUp } from "./helpers/plainSlide.js";

/**
 * Menu opener
 */
class Menu {
  constructor() {
    this.body = document.querySelector("body");
    this.header = document.querySelector(".site-header");
    this.menuOpener = document.querySelector(".js-menu-opener");
    this.menuOpenerScreenReaderText = this.menuOpener
      ? this.menuOpener.querySelector(".screen-reader-text")
      : false;
    this.menuWrapper = document.querySelector(".site-header__menu");
    this.menuIsActive = false;

    if (this.menuOpener && this.menuWrapper) {
      this.initMenuOpener();

      // Handle dropdown links
      this.initDropdownMenuOpeners();
    }
  }

  /**
   * Inits Menu opener
   */
  initMenuOpener() {
    const that = this;
    that.menuOpener.onclick = (e) => {
      e.preventDefault();

      if (that.menuIsActive) {
        that.deactivateMenu();
      } else {
        that.activateMenu();
      }
    };
  }

  /**
   * Activates Burger Menu for smaller screens
   */
  activateMenu() {
    this.body.classList.add("js-menu-active");
    this.header.classList.add("site-header--sticky");
    this.menuOpenerScreenReaderText
      ? (this.menuOpenerScreenReaderText.innerHTML = "Stäng menyn")
      : false;

      setTimeout(() => {
      this.menuIsActive = true;
      setTimeout(() => { 
        slideDown(this.menuWrapper, 200, 'flex');
      }, 300);
    }, 100);
  }

  /**
   * Deactivates Burger Menu for smaller screens
   */
  deactivateMenu() {
    this.menuOpenerScreenReaderText
    ? (this.menuOpenerScreenReaderText.innerHTML = "Öppna menyn")
    : false;
    
    setTimeout(() => {
      this.menuIsActive = false;
      slideUp(this.menuWrapper);
      window.scrollY > 50 ? false : this.header.classList.remove("site-header--sticky");
      setTimeout(() => { this.body.classList.remove("js-menu-active")}, 200);
    }, 100);
  }

  /**
   * Handles dropdown menu functionality
   */
  initDropdownMenuOpeners() {
    const that = this;
    if (
      this.menuWrapper &&
      this.menuWrapper.querySelector(".js-toggle-dropdown-menu")
    ) {
      this.menuWrapper
        .querySelectorAll(".js-toggle-dropdown-menu")
        .forEach((opener) => {
          if (opener && opener.nextElementSibling) {
            const dropdownElement = opener.nextElementSibling;

            opener.onclick = (e) => {
              e.preventDefault();

              // check and close other dropdown menus if open
              that.closeOtherDropdownMenus(opener.parentElement);

              if (
                !opener.parentElement.classList.contains("js-dropdown--active")
              ) {
                slideDown(dropdownElement);
                opener.parentElement.classList.add("js-dropdown--active");
              } else {
                slideUp(dropdownElement);
                opener.parentElement.classList.remove("js-dropdown--active");
              }
            };
          }
        });
    }
  }

  /**
   * Closes other active dropdowm menus
   */
  closeOtherDropdownMenus(currentMenuItem) {
    const navList = currentMenuItem.parentElement;
    const otherActiveMenuItem = navList.querySelector(
      ".js-dropdown--active .sub-menu",
    );

    if (
      currentMenuItem &&
      otherActiveMenuItem &&
      currentMenuItem !== otherActiveMenuItem.parentElement
    ) {
      document
        .querySelector(".js-dropdown--active")
        .classList.remove("js-dropdown--active");
      slideUp(otherActiveMenuItem);
    }
  }
}

new Menu();
